import { useSelector } from 'hooks/utils';
import { selectTemplates } from 'store/data/templates';

export function useFetchedTemplates() {
	return useSelector(state => selectTemplates(state.data.templates));
}
